module.exports = __webpack_public_path__ + "img/weather.dbb49a7a.jpg";